// Module
var code = `<div class="empty-table-container"> <div class="alert alert-info m-b-0"> <h4 class="p-t-5" translate>Generic.NoResults</h4> <h5 ng-if="noResultsController.explain" translate> {{ noResultsController.explain }} </h5> </div> </div> `;
// Exports
module.exports = code;